import { H3 } from "@alternative/components";
import React, { Suspense, useEffect } from "react";
import { RecoilRoot, useRecoilState, useSetRecoilState } from "recoil";
import FileManager from "./components/filemanager";
import ColorEditorContainer from "./components/coloreditor";
import { getLoginUrl } from "./constants";
import { apiKeyState, userDetailState } from "./recoil/filemanager/atoms";
import LoginPage from "./components/login";
const acceptedOrigins = [
  "http://localhost:23456",
  "https://v3.explorug.com",
  "https://v3rc.explorug.com",
  "https://v3dev.explorug.com",
];
const AppWithLogin = () => {
  const [apiKey, setApiKey] = useRecoilState(apiKeyState);
  const setUserDetails = useSetRecoilState(userDetailState);
  useEffect(() => {
    const key = sessionStorage.getItem("apikey");
    if (key && key !== "" && key !== "null" && key !== "undefined") setApiKey(key);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return apiKey ? (
    <div>
      <div className="at-navbar">
        <img src="https://explorug.net/new/explorug-logo.png" alt="explorug-logo" />
        <H3>Design Manager</H3>
      </div>
      {/* <ColorEditorContainer /> */}
      <FileManager />
    </div>
  ) : (
    <LoginPage />
  );
};
function App() {
  return (
    <RecoilRoot>
      <Suspense fallback={<></>}>
        <AppWithLogin />
      </Suspense>
    </RecoilRoot>
  );
}

export default App;
